/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import './index.css';
import App from './App';
import TagManager from 'react-gtm-module';
import { GTM_ID_INTERNAL, GTM_ID_EXTERNAL, GA4_ID_PARTNER, INTERNAL_PORTAL_URL, EXTERNAL_PORTAL_URL, PARTNER_PORTAL_URL } from './config';

const origin = window.location.origin;

if (origin === PARTNER_PORTAL_URL) {
	// Partner portal uses direct GA4 (gtag.js)
	const gtagScript = document.createElement('script');
	gtagScript.async = true;
	gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID_PARTNER}`;
	document.head.appendChild(gtagScript);
	window.dataLayer = window.dataLayer || [];
	window.gtag = function () { window.dataLayer.push(arguments); };
	window.gtag('js', new Date());
	window.gtag('config', GA4_ID_PARTNER);
} else {
	const getGtmIdAccToOrigin = () => {
		switch (origin) {
			case INTERNAL_PORTAL_URL:
				return GTM_ID_INTERNAL;
			case EXTERNAL_PORTAL_URL:
				return GTM_ID_EXTERNAL;
			default:
				return undefined;
		}
	};
	const gtmId = getGtmIdAccToOrigin();
	if (gtmId) {
		TagManager.initialize({ gtmId });
	}
}

ReactDOM.render(
	<Provider store={store}>
		<Router>
			<PersistGate persistor={persistor}>
				<React.StrictMode>
					<App />
				</React.StrictMode>
			</PersistGate>
		</Router>
	</Provider>,
	document.getElementsByTagName('body')[0],
);
